import { request } from './axios.config';

export const article = {
    async getArticle(id: number | string): Promise<IArticle> {
        return request.get<IArticle>(isCampaignTemplateId(id) ? '/campaigntemplate/get' : '/emailtemplate/get', {
            params: {
                id: campaignGuid(id) ?? id
            },
        });
    },

    async updateArticle(
        id: number | string,
        options: {
            revision?: number;
            subject: string;
            subtitle: string;
            json: string;
            mjml: string;
            html: string;
            previewImage: string;
        }
    ): Promise<IArticle | undefined> {
        return request.post<IArticle | undefined>(isCampaignTemplateId(id) ? '/campaigntemplate/edit' : '/emailtemplate/edit', {
            ...options,
            id: campaignGuid(id) ?? id
        });
    }
};

export interface ListResponse<T> {
    list: T[];
    count: number;
}

export interface IArticle {
    id: number | string;
    revision?: number;
    subject: string;
    subTitle: string;
    json: string;
    mjml: string;
    html: string;
    datecreated: string;
    previewimage: string;

}

const campaignPrefix = 'campaign-';

function isCampaignTemplateId(id: number | string): boolean {
    return typeof id === 'string' && id.startsWith(campaignPrefix);
}

function campaignGuid(id: number | string): string | null {
    return isCampaignTemplateId(id) ? String(id).slice(campaignPrefix.length) : null;
}
